import { FC, useEffect, useState } from 'react';
import { FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SCUIButton } from '../../../../atomic/atoms';
import { SCUIGeneralDrawerHeader } from '../../../../atomic/molecules';
import { LocalizationManagementQuery } from '../../../../services/query';
import EmailTemplateBuilderCommand from '../../../../services/command/emailTemplateBuilder/EmailTemplateBuilderCommand.services';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import { sectionTypes } from '../../EmailTemplateBuilder.config';
import { SearchableCountrySelect } from '../../components/SearchableCountrySelect';
import { ETBED_INFOS, etbCls } from '../../emailTemplateBuilder.classes';

interface IProps {
    onClose?: any;
    sectionInfos?: any;
    setSectionInfos?: any;
    editorContent?: any;
}
export const AddOrEditSectionInfos: FC<IProps> = ({ onClose, sectionInfos, setSectionInfos, editorContent }) => {
    const { t } = useTranslation();
    const [languageList, setLanguageList] = useState<any>();
    const history = useHistory();

    useEffect(() => {
        GetLanguageList();
    }, []);

    const GetLanguageList = async () => {
        let serviceResponse: any = await LocalizationManagementQuery.CultureList();
        setLanguageList(serviceResponse.data);
    };

    const AddSection = async () => {
        if (!sectionInfos) {
            return;
        }

        let sectionsAddReq = {
            name: sectionInfos.name,
            keyword: sectionInfos.key,
            content: editorContent,
            languageCode: sectionInfos.languageCode,
            countryCode: sectionInfos.countryCode,
            type: sectionInfos.type,
        };
        EmailTemplateBuilderCommand.AddSection(sectionsAddReq)
            .then(() => {
                Swal.fire(t('general.added'), ' ', 'success');
                setTimeout(() => {
                    history.push('/emailTemplateBuilder/sectionGallery');
                }, 1000);
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            });
    };
    const UpdateSection = async () => {
        let sectionsUpdateReq = {
            sectionId: sectionInfos.sectionId,
            name: sectionInfos.name,
            key: sectionInfos.key,
            content: editorContent,
            languageCode: sectionInfos.languageCode,
            countryCode: sectionInfos.countryCode,
            type: sectionInfos.type,
        };
        EmailTemplateBuilderCommand.UpdateSection(sectionsUpdateReq)
            .then(() => {
                Swal.fire(t('general.updated'), ' ', 'success');
                setTimeout(() => {
                    history.push('/emailTemplateBuilder/sectionGallery');
                }, 1000);
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            });
    };

    const handleAddButton = () => {
        AddSection();
    };

    const handleUpdateButton = () => {
        UpdateSection();
    };

    return (
        <form
            onSubmit={(e: any) => {
                e.preventDefault();
            }}
        >
            <div className={etbCls('commentFilterContainer', ETBED_INFOS.shell)}>
                {
                    <Grid container spacing={1}>
                        {!sectionInfos?.sectionId ? (
                            <SCUIGeneralDrawerHeader
                                header={t('emailTemplateBuilder.addExistSection')}
                                onClose={onClose}
                            />
                        ) : (
                            <SCUIGeneralDrawerHeader
                                header={t('emailTemplateBuilder.update')}
                                onClose={onClose}
                            ></SCUIGeneralDrawerHeader>
                        )}
                        <Grid
                            className={ETBED_INFOS.fieldSectionName}
                            style={{ marginTop: '2rem' }}
                            size={{
                                xs: 12,
                                md: 12,
                                lg: 12,
                                xl: 12,
                            }}
                        >
                            <TextField
                                className={ETBED_INFOS.inputTextfieldSectionName}
                                id="sectionName"
                                defaultValue={sectionInfos && sectionInfos.name}
                                type="text"
                                label={t('emailTemplateBuilder.sectionName')}
                                fullWidth
                                onChange={(event: any) => {
                                    setSectionInfos({
                                        ...sectionInfos,
                                        name: event.target.value,
                                    });
                                }}
                            />
                        </Grid>
                        <Grid
                            className={ETBED_INFOS.fieldKeyword}
                            style={{ marginTop: '2rem' }}
                            size={{
                                xs: 12,
                                md: 12,
                                lg: 12,
                                xl: 12,
                            }}
                        >
                            <TextField
                                className={ETBED_INFOS.inputTextfieldKeyword}
                                id="keyword"
                                defaultValue={sectionInfos && sectionInfos.key}
                                type="text"
                                label={t('emailTemplateBuilder.keyword')}
                                fullWidth
                                onChange={(event: any) => {
                                    setSectionInfos({ ...sectionInfos, key: event.target.value });
                                }}
                            />
                        </Grid>
                        {languageList && (
                            <Grid
                                className={ETBED_INFOS.fieldLanguage}
                                style={{ marginTop: '2rem' }}
                                size={{
                                    xs: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12,
                                }}
                            >
                                <FormControl style={{ width: 345 }}>
                                    <InputLabel id="labelApp">{t('emailTemplateBuilder.selectLanguage')}</InputLabel>
                                    <Select
                                        className={ETBED_INFOS.inputSelectLanguage}
                                        label={t('emailTemplateBuilder.selectLanguage')}
                                        labelId="labelApp"
                                        id="parentMenuLabel"
                                        value={sectionInfos ? sectionInfos.languageCode : 'tr-TR'}
                                        onChange={(event) => {
                                            setSectionInfos({
                                                ...sectionInfos,
                                                languageCode: event.target.value,
                                            });
                                        }}
                                        fullWidth
                                    >
                                        {languageList &&
                                            languageList.map((language: any) => (
                                                <MenuItem key={language.code} id={language.id} value={language.code}>
                                                    {language.code}
                                                </MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        )}
                        <Grid
                            className={ETBED_INFOS.fieldCountry}
                            style={{ marginTop: '2rem' }}
                            size={{
                                xs: 12,
                                md: 12,
                                lg: 12,
                                xl: 12,
                            }}
                        >
                            <SearchableCountrySelect
                                value={sectionInfos?.countryCode || ''}
                                onChange={(value) => {
                                    setSectionInfos({
                                        ...sectionInfos,
                                        countryCode: value,
                                    });
                                }}
                                fullWidth={false}
                                style={{ width: 345 }}
                            />
                        </Grid>
                        {sectionTypes.length > 0 && (
                            <Grid
                                className={ETBED_INFOS.fieldSectionType}
                                style={{ marginTop: '2rem' }}
                                size={{
                                    xs: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12,
                                }}
                            >
                                <FormControl style={{ width: 345 }}>
                                    <InputLabel id="labelApp">{t('emailTemplateBuilder.sectionType')}</InputLabel>
                                    <Select
                                        className={ETBED_INFOS.inputSelectSectionType}
                                        label={t('emailTemplateBuilder.sectionType')}
                                        labelId="labelApp"
                                        id="parentMenuLabel"
                                        value={sectionInfos?.type}
                                        onChange={(event) => {
                                            setSectionInfos({
                                                ...sectionInfos,
                                                type: event.target.value,
                                            });
                                        }}
                                        fullWidth
                                    >
                                        {sectionTypes &&
                                            sectionTypes.map((section: any) => (
                                                <MenuItem key={section.key} id={section.id} value={section.id}>
                                                    {section.name}
                                                </MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        )}
                        <Grid
                            className={ETBED_INFOS.spacerGrid}
                            container
                            spacing={1}
                            sx={{ minHeight: { xs: 250, lg: 450 }, paddingBottom: '1rem' }}
                        ></Grid>
                        {!sectionInfos?.sectionId ? (
                            <Grid
                                className={ETBED_INFOS.actionsFooterAdd}
                                style={{
                                    position: 'absolute',
                                    bottom: 0,
                                    width: 380,
                                    marginBottom: '20px',
                                }}
                            >
                                <SCUIButton
                                    className={ETBED_INFOS.inputButtonAdd}
                                    text={t('general.add')}
                                    type="primary"
                                    sizeType="default"
                                    buttonType="submit"
                                    size={'s'}
                                    fullwidth
                                    onClick={handleAddButton}
                                />
                            </Grid>
                        ) : (
                            <Grid
                                className={ETBED_INFOS.actionsFooterUpdate}
                                style={{
                                    position: 'absolute',
                                    bottom: 0,
                                    width: 380,
                                    marginBottom: '20px',
                                }}
                            >
                                <SCUIButton
                                    className={ETBED_INFOS.inputButtonUpdate}
                                    text={t('general.update')}
                                    type="primary"
                                    sizeType="default"
                                    buttonType="submit"
                                    size={'s'}
                                    fullwidth
                                    onClick={handleUpdateButton}
                                />
                            </Grid>
                        )}
                    </Grid>
                }
            </div>
        </form>
    );
};
